import {Injectable} from '@angular/core';
import {Callback} from '../models/callback';
import 'rxjs/add/operator/toPromise';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class CallbackService {
  constructor(private http: HttpClient) {
  }

  post(url, data) {
    return this.http.post(
      url,
      JSON.stringify(data),
    );
  }

  sendCallback(callback: Callback) {
    return this.post(
      environment.zapierCallbackWebhook,
      callback
    );
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/callback.service.ts